module.exports = __webpack_public_path__ + "img/maria-es.97e3daa1.png";